import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setAppTitle } from '../../../store/commonSlice'
import { ApiServiceContext } from '../../../utils/shared.module'
import { end_points } from '../../../services/core.index'
import { Link } from 'react-router-dom'
import TruckListView from './truckListView'
import TruckGridView from './truckGridView'
import { routes } from '../../../utils/routes'

import {
  chart,
  truck1,
  truck2,
  truck3,
  truck4,
  truck5,
  truck6,
  truck7,
} from '../../../utils/images/imagepath'

import {
  avatar1,
  avatar11,
  avatar13,
  avatar17,
  avatar2,
  avatar29,
  avatar30,
} from '../../../utils/images/imagepath'

function TruckList() {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState<boolean>(false)
  const { getData } = useContext(ApiServiceContext)
  const [listData, setListData] = useState<any>([])
  const [totalPage, setTotal] = useState<number>(0)
  const [page, setPage] = useState<number>(1)
  const [limitCount] = useState<number>(100)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [view, setView] = useState('list')

  const toggleView = () => {
    setView((prevView) => (prevView === 'list' ? 'grid' : 'list'))
  }

  const getTruckList = async (search?: any) => {
    let nameSearch = search
    if (nameSearch == undefined) {
      nameSearch = ''
    }
    const urls = end_points.getTrucks.url
    // urls += `?page=${page}&limit=${limitCount}&searchTerm=${nameSearch}`

    const response = await getData(urls)
    if (response?.status == 200) {
      setListData(response?.data?.data)
      // setTotal(response?.data?.total_records)

      setLoading(false)
    }
  }

  useEffect(() => {
    getTruckList()
  }, [])

  useEffect(() => {
    dispatch(setAppTitle('Truck List'))
  }, [])

  const data = listData.map((item: any) => {
    return {
      id: item?.id,
      driver_name: item?.username,
      company_name: item?.companyName,
      license_number: item?.license_Plate,
      phone_number: item?.phoneNumber,
      truck_number: item?.vin_Number,
      year: item?.year,
      model_name: item?.model,
      status: item?.truck_Status ? 'active' : 'inactive',
      user_id: item?.userId,
      truck_id: item?.truck_Id,
    }
  })

  const truckDetails = (data: any, index: any) => {
    return (
      <>
        <td>
          <h2 className='table-avatar'>
            <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
              <img
                className='avatar-img rounded-circle'
                src={truck2}
                alt='Profiles'
              />
            </a>
            <a href='javascript:void(0);'>
              {data.model_name} <span>{data.vin_number}</span>
            </a>
          </h2>
        </td>
      </>
    )
  }

  const driverDetails = (data: any, index: any) => {
    return (
      <>
        <td>
          <h2 className='table-avatar'>
            <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
              <img
                className='avatar-img rounded-circle'
                src={avatar1}
                alt='Profiles'
              />
            </a>
            <a href='javascript:void(0);'>
              Cameron Jacob <span>ABC Company</span>
            </a>
          </h2>
        </td>
        <td>
          <h2 className='table-avatar'>
            <a href='javascript:void(0);' className='avatar avatar-sm me-2'>
              <img
                className='avatar-img rounded-circle'
                src={avatar1}
                alt='Profiles'
              />
            </a>
            <a href='javascript:void(0);'>
              Cameron Jacob <span>ABC Company</span>
            </a>
          </h2>
        </td>
      </>
    )
  }

  const inspectorDetails = (data: any, index: any) => {
    return (
      <>
        <td>Cameron Jacob</td>
        <td>Cameron Jacob</td>
      </>
    )
  }

  const inspectionDate = (data: any, index: any) => {
    return (
      <>
        <td>04-06-2024 10AM</td>
        <td>04-06-2024 10AM</td>
      </>
    )
  }

  const checkList = (data: any, index: any) => {
    return (
      <>
        <td>
          <div className='data-check-list'>
            <ul className='nav'>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
            </ul>
            <p>
              28/<span>30</span>
              <Link className='view-checklist' to={routes.CheckList.path}>
                View Checklist
              </Link>
            </p>
          </div>
        </td>
        <td>
          <div className='data-check-list'>
            <ul className='nav'>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
              <li>
                <span className='check-list-active'></span>
              </li>
            </ul>
            <p>
              28/<span>30</span>
              <Link className='view-checklist' to={routes.truckCheckList.path}>
                View Checklist
              </Link>
            </p>
          </div>
        </td>
      </>
    )
  }

  const status = (data: any, index: any) => {
    return (
      <>
        <td>
          <span className='badge bg-light-success'>{data.status}</span>
        </td>

        <td>
          <span className='badge bg-light-success'>{data.status}</span>
        </td>
      </>
    )
  }

  const action = (data: any, index: any) => {
    return (
      <>
        <td className='table-action'>
          <div className='dropdown'>
            <a
              href='javascript:void(0);'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
            >
              <i className='feather-more-vertical'></i>
            </a>
            <div className='dropdown-menu dropdown-menu-end'>
              <a href='javascript:void(0);' className='dropdown-item'>
                <i className='feather-eye'></i> View
              </a>
              <a href='javascript:void(0);' className='dropdown-item'>
                <i className='feather-edit'></i> Edit
              </a>
              <a href='javascript:void(0);' className='dropdown-item'>
                <i className='feather-trash-2'></i> Delete
              </a>
            </div>
          </div>
        </td>
      </>
    )
  }

  return (
    <>
      <div className='content container-fluid'>
        <div className='page-header'>
          <div className='row align-items-center'>
            <div className='col-sm-6'>
              <h3 className='page-title'>Truck List</h3>
            </div>
            <div className='col-sm-6'>
              <ul className='breadcrumb'>
                <li className='breadcrumb-item active'>
                  <a href='index.html'>Home</a>
                </li>
                <li className='breadcrumb-item'>Truck List</li>
              </ul>
            </div>
          </div>
        </div>

        <div className='row align-items-center'>
          <div className='col-md-6'>
            <div className='truck-list'>
              <ul className='nav'>
                <li className='active'>
                  <a href='javascript:void(0);'>All</a>
                </li>
                <li>
                  <a href='javascript:void(0);'>Active</a>
                </li>
                <li>
                  <a href='javascript:void(0);'>Minor</a>
                </li>
                <li>
                  <a href='javascript:void(0);'>Blocker</a>
                </li>
              </ul>
              <div className='truck-view'>
                <Link
                  to=''
                  className={view === 'list' ? 'active' : ''}
                  onClick={toggleView}
                >
                  <i className='feather-server'></i>
                </Link>
                <Link
                  to=''
                  className={view === 'grid' ? 'active' : ''}
                  onClick={toggleView}
                >
                  <i className='feather-grid'></i>
                </Link>
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='truck-search'>
              <div className='truck-search-input'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search...'
                />
              </div>
              <div className='truck-search-filter'>
                <a href='javascript:void(0);' className='btn btn-light'>
                  Filters <i className='ti ti-filter'></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='card table-card'>
              <div className='card-body'>
                <div className='row align-items-center'>
                  <div className='col-md-6'>
                    <div id='tablelength'></div>
                  </div>
                  <div className='col-md-6'>
                    <ul className='nav nav-table-filter'>
                      <li>Search:</li>
                      <li>
                        <div id='tablefilter'></div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='table-responsive'>
                  <table className='table datatable mb-0'>
                    {view === 'list' && <TruckListView data={data} />}

                    {view === 'grid' && <TruckGridView data={data} />}
                  </table>
                </div>
                <div className='tab-footer'>
                  <div className='row align-items-center'>
                    <div className='col-md-6'>
                      <div id='tableinfo'></div>
                    </div>
                    <div className='col-md-6'>
                      <div id='tablepage'></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default TruckList
